import '../css/main.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Swal from 'sweetalert2';
import u from 'umbrellajs';
import cookieconsent from "cookieconsent";


window.addEventListener('DOMContentLoaded', () => {
  window.cookieconsent.initialise({
    "palette": {
      "popup": {
        "background": "#f1f3f4",
        "text": "#646667"
      },
      "button": {
        "background": "#d30073"
      }
    },
    "content": {
      "message": "Diese Internetseite benutzt sog. Cookies (kleine Textdateien) für die korrekte Darstellung von Inhalten.",
      "dismiss": "OK, Einverstanden.",
      "link": "Datenschutz",
      "href": "https://pohlevents.de/datenschutz/"
    }
  })

  u('#cat-select').on('change', () => {
    u('#cat-form').first().submit();
  });

  u('.submit-link').on('click', () => {
    u('#cat-form').append('<input type="hidden" name="submitted" value="1" />');
    u('#cat-form').first().submit();
  });


  u('.delete-link').on('click', () => {
    Swal.fire({
      title: 'Willst du diese Kategorie wirklich löschen (die Unterseiten bleiben erhalten)?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then(function (result) {
      if (result.value) {
        u('#cat-form').append('<input type="hidden" name="deleted" value="1" />');
        u('#cat-form').first().submit();
      }
    });
  });


  u('.deletepartner').on('click', (event) => {
    event.preventDefault();
    const form = u(event.currentTarget).closest('form');
    Swal.fire({
      title: 'Soll dieser Eintrag wirklich gelöscht werden?',
      icon: 'warning',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
      showCancelButton: true,
    }).then(function (result) {
      if (result.value) {
        form.first().submit();
      }
    });
    return false;
  });

  const subcatRow = `
    <div class="subcat-row row mb-3" draggable="true">
      <div class="col-1">
        <button class="btn btn-secondary">
          <i class="bi bi-arrow-down-up"></i>
        </button>
      </div>
      <div class="col">
        <input type="text" name="subcat_name[]" class="subcat_name form-control" />
      </div>
      <div class="col">
        <input type="text" name="subcat_link[]" class="subcat_link form-control" />
      </div>
      <div class="col-3">
        <a href="#" class="subcat-delete btn btn btn-danger">Löschen</a>
      </div>
    </div>
  `;

  u('#subcat-add').on('click', (event) => {
    event.preventDefault();
    u('.subcat-header').removeClass('d-none');
    u('#subcat-ct').prepend(subcatRow);
  });

  let draggedElement;

  u(document).on('dragstart', '.subcat-row', (event) => {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/html', event.target.innerHTML);
    draggedElement = event.target;
  });

  u(document).on('dragover', '.subcat-row', (event) => {
    if (event.preventDefault) {
      event.preventDefault(); // Necessary. Allows us to drop.
    }
    event.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

    return false;
  });

  u(document).on('drop', '.subcat-row', (event) => {

    event.stopPropagation();
    let target = u(event.target).closest('.subcat-row').first();

    let targetInnerHtml = target.innerHTML;
    target.innerHTML = event.dataTransfer.getData('text/html')
    draggedElement.innerHTML = targetInnerHtml;
    return false;
  });

  const ckCt = u('#ck-ct');
  if (ckCt.length) {
    import('@ckeditor/ckeditor5-build-classic').then(function (ClassicEditor) {
      ClassicEditor
        .create(
          document.querySelector( '#ck-ct' ),
          {
            //toolbar: [ 'bold', 'italic', 'link', 'undo', 'redo', 'numberedList', 'bulletedList' ],
            resize_enabled: false,
            height: 800,
            width: '100%',
            language: 'de'
          }
        )
        .then( editor => {
          u('.send-details').on('click', function() {
            let formBody = [
              "data="+encodeURIComponent(editor.getData()),
              "data_id="+u('#data_id').first().value
            ];
            formBody = formBody.join("&");

            fetch(window.url+'/edit', {
              method: 'post',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: formBody
            }).then(() => {
              window.location.reload();
            })
          });
        } )
        .catch( error => {
          console.error( 'There was a problem initializing the editor.', error );
        } );
    });

    ckCt.after('<button class="btn btn-success mt-3 mb-3 send-details">Absenden</button>');
  }

  if (typeof(window.controller) != 'undefined' && window.controller === 'kontakt') {
    u('#cat-form').attr('action', '/kontakt/');
    u('#submit-ct').append('<button type="submit" name="con_submit" id="con_submit" class="btn btn-success mb-3">Abschicken</button>');
  }

  u('#con_submit').on('click', (event) => {
    const contactForm = u('#cat-form').first();
    event.preventDefault();

    if (u('#con_name').first().value.length < 1
      || u('#con_email').first().value.length < 1
      || u('#con_subject').first().value.length < 1
      || u('#con_text').first().value.length < 1
    ) {
      Swal.fire('Bitte füllen Sie alle Felder des Formulars aus.');
      return false;
    }

    contactForm.submit();

  });

  const max_len = parseInt(u('#con_text_len').first().innerText);
  u('#con_text').on('keyup', () => {
    u('#con_text_len').first().innerText = max_len - u('#con_text').first().textLength;
    u('#con_text').first().value = u('#con_text').first().value.substr(0, max_len);
  });


  u(document).on('click', '.subcat-delete', (event) => {
    event.preventDefault();
    const self = u(event.target);
    const subId = self.attr('data-sub_id');
    if (!subId) {
      self.closest('.subcat-row').remove();
      return;
    }

    fetch('/admin/referenzen/?sub_delete='+subId)
      .then((d) => {
        return d.text();
      })
      .then((text) => {
        if (text !== "OK") {
          alert("Fehler! "+text);
          return;
        }
        self.closest('.subcat-row').remove();
      })
  });

  u(document).on('keyup', '.subcat_name', (event) => {
    const self = u(event.target);
    const row = self.closest('.subcat-row');
    const linkField = row.find('.subcat_link');
    linkField.first().value = self.first().value
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/[ß]/g, 'ss')
      .replace(/[^a-z0-9]/g, '-');

  });


  u('.ref-img-small').on('click', (event) => event.preventDefault());

  u('.ref-img-small').on('mouseover', (event) => {
    const self = u(event.currentTarget);
    const container = self.closest('.ref-img-ct');

    if (self.find('img').hasClass('ref-img-active'))
      return false;

    container.find('.ref-img-small img').removeClass('ref-img-active');
    self.find('img').addClass('ref-img-active');
    container.find('.ref-img-big').first().style.backgroundImage = 'url('+self.find('a').attr('href')+')';
    return false;
  });

});
